module.exports = __webpack_public_path__ + "img/logo.bdc72378.png";